import { ActiveStorageAttachment } from "types/activeStorageAttachment";

export const COI_ON_RECORD = "required";
export const COI_EACH_PICKUP = "required_renewal";

export const MISSING_CERTIFICATE_MESSAGE = "Upload a certificate of insurance before submitting this pickup request.";

type CertificateFile = ActiveStorageAttachment | string | null | undefined;

export function coiUploadApplies(option: string | null | undefined) {
  return option === COI_ON_RECORD || option === COI_EACH_PICKUP;
}

export function coiStoredOnLocation(option: string | null | undefined) {
  return option === COI_ON_RECORD;
}

export function hasCertificateAttachment(file: CertificateFile) {
  if (!file) return false;
  if (typeof file === "string") return file.length > 0;
  return Boolean(file.url);
}

export function missingRequiredCertificate({
  option,
  locationFile,
  pickupFile,
}: {
  option: string | null | undefined;
  locationFile?: CertificateFile;
  pickupFile?: CertificateFile;
}) {
  if (!coiUploadApplies(option)) return false;

  const file = coiStoredOnLocation(option) ? locationFile : pickupFile;
  return !hasCertificateAttachment(file);
}
